"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxDocumentElement = void 0;
const react_1 = __importStar(require("react"));
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const doshx_controls_web_1 = require("doshx_controls_web");
const react_redux_1 = require("react-redux");
const document_1 = require("../../../../../../reducers/slices/document/document");
const constants_1 = require("../../../../../../constants/constants");
const ui_1 = require("../../../../../../reducers/slices/ui");
const main_1 = require("../../../../../../reducers/slices/main");
const lock_user_1 = __importDefault(require("../lock_user"));
const update_single_element_thunk_1 = require("../../../../../../reducers/slices/document/thunks/update/update_single_element_thunk");
const react_2 = require("@heroui/react");
const testHelpers_1 = require("../../../../../../helpers/testHelpers");
const type = "Checkbox";
// Note: Scaling is handled by PreviewDocumentElementWrapper - this component renders at 100%
exports.CheckboxDocumentElement = {
    type,
    sideBarComponent: SideBarComponent,
    documentComponent: DocumentComponent,
    propertiesComponent: () => react_1.default.createElement("div", null, "Properties Components"),
    construct: (_id, page) => {
        return {
            _id,
            type,
            page,
            // Explicit dimensions match HeroUI Checkbox natural render
            // (~30-40px tall — checkboxes are shorter than text inputs).
            width: 200,
            height: 40,
            extra_attributes: {
                checked: false,
                label: "",
                user: null,
                helperText: "Helper text",
                required: false,
                palcehlolder: "placeHolder",
                edit_type: "fillable",
                x: 0,
                y: 0,
            },
        };
    },
    sidebarBtnElement: {
        icon: pro_light_svg_icons_1.faCheckSquare,
        label: "Checkbox",
    },
};
function DocumentComponent({ elementInstance }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { selectedDocument, documentErrors, documentState, selectedDocumentElements } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const { user, accessAuth } = (0, react_redux_1.useSelector)((state) => state.userState);
    const { loginAuthenticated } = (0, react_redux_1.useSelector)((state) => state.uiState);
    const stateCheck = documentState === constants_1.TYPE_LINK;
    const isDraftMode = documentState !== constants_1.TYPE_LINK;
    const _element = (_a = selectedDocumentElements.find((x) => x._id === elementInstance._id)) !== null && _a !== void 0 ? _a : elementInstance;
    // Field is editable if: no user assigned OR assigned to current user.
    // Mirrors the wrapper/signature/initials check (preview_document_element_wrapper.tsx,
    // siganture.tsx) — assignment can match by email, accessAuth.user_id (mobile/access
    // link signers), or user._id (logged-in users).
    const assignedEmail = (_c = (_b = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.email;
    const assignedUserId = ((_d = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _d === void 0 ? void 0 : _d.user_id) || ((_f = (_e = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _e === void 0 ? void 0 : _e.user) === null || _f === void 0 ? void 0 : _f._id);
    const hasAssignment = !!(assignedEmail || assignedUserId);
    const isCurrentUserByEmail = !!(assignedEmail && (user === null || user === void 0 ? void 0 : user.email) && assignedEmail.toLowerCase() === user.email.toLowerCase());
    const isCurrentUserById = !!(assignedUserId && (((accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.user_id) && String(assignedUserId) === String(accessAuth.user_id)) ||
        ((user === null || user === void 0 ? void 0 : user._id) && String(assignedUserId) === String(user._id))));
    const isUser = isDraftMode || !hasAssignment || isCurrentUserByEmail || isCurrentUserById;
    // Document must be in active signing flow (SENT → VIEWED → SIGNING)
    // Allow editing in test mode, with FaceTec authorization, OR with valid access code
    // In draft mode, fields should NOT be editable (only configurable via properties sidesheet)
    const isTestMode = (0, testHelpers_1.isTestModeEnabled)();
    const isInSigningFlow = (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) === "SENT" || (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) === "VIEWED" || (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) === "SIGNING";
    const isEditable = !isDraftMode && isInSigningFlow && (isTestMode || loginAuthenticated || !!accessAuth) && isUser;
    // Scaling is handled by PreviewDocumentElementWrapper - this component renders at 100%
    return (react_1.default.createElement("div", { onClick: (e) => {
            // In draft mode, clicking should select the field for property editing
            if (isDraftMode) {
                e.stopPropagation();
                dispatch((0, document_1.setSelectedElementID)(_element._id));
                dispatch((0, document_1.setSelectedElement)(_element));
                return;
            }
            // Once we can identify the current signer (logged in, access-link, or
            // test mode), check field assignment before prompting for FaceTec —
            // an access-link signer who taps another signer's field should see
            // "Field Not Assigned", not the QR auth screen.
            if ((selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) !== "COMPLETED" && isInSigningFlow) {
                const isMobileUser = (accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.view_type) === constants_1.VIEW_TYPE.MOBILE;
                const canIdentifySigner = loginAuthenticated || !!accessAuth || isTestMode || !!(user === null || user === void 0 ? void 0 : user._id);
                if (canIdentifySigner && !isUser) {
                    e.preventDefault();
                    dispatch((0, main_1.setMessageModal)({
                        title: "Field Not Assigned",
                        messages: ["This checkbox is assigned to another signer. You cannot change it."],
                    }));
                    return;
                }
                if (!loginAuthenticated && !isTestMode && !isMobileUser) {
                    e.preventDefault();
                    dispatch((0, ui_1.showQrAuth)());
                    return;
                }
            }
            if (!isEditable) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
        }, style: {
            opacity: !isEditable ? 0.6 : 1,
            cursor: !isUser ? "not-allowed" : "default",
            userSelect: "none",
            WebkitUserSelect: "none",
        }, className: "w-full" },
        react_1.default.createElement(react_2.Checkbox, { color: "primary", isSelected: (_g = _element.extra_attributes) === null || _g === void 0 ? void 0 : _g.checked, isDisabled: !isEditable, isRequired: (_h = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _h === void 0 ? void 0 : _h.required, isInvalid: documentErrors.includes(_element._id), classNames: {
                wrapper: documentErrors.includes(_element._id) ? "border-error border-2" : "border-gray-400 border-2 before:bg-gray-200",
            }, onChange: (e) => {
                if (isEditable) {
                    dispatch((0, update_single_element_thunk_1.update_single_element_thunk)({
                        data: {
                            document_id: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id,
                            payload: Object.assign(Object.assign({}, _element), { extra_attributes: Object.assign(Object.assign({}, _element.extra_attributes), { checked: e.target.checked }) }),
                        },
                    }));
                }
            } }, ((_j = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _j === void 0 ? void 0 : _j.label) || "")));
}
function SideBarComponent({ elementInstance }) {
    var _a, _b, _c, _d;
    const { selectedDocument, selectedDocumentElements } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const dispatch = (0, react_redux_1.useDispatch)();
    const _element = (_a = selectedDocumentElements.find((x) => x._id === elementInstance._id)) !== null && _a !== void 0 ? _a : elementInstance;
    // Initialize with existing value and track if user has made changes
    const [label, setLabel] = (0, react_1.useState)(((_b = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _b === void 0 ? void 0 : _b.label) || "");
    const [hasUserEdited, setHasUserEdited] = (0, react_1.useState)(false);
    // Sync label state when element changes (e.g., switching between fields)
    (0, react_1.useEffect)(() => {
        var _a;
        setLabel(((_a = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _a === void 0 ? void 0 : _a.label) || "");
        setHasUserEdited(false);
    }, [_element === null || _element === void 0 ? void 0 : _element._id]);
    // Only save when user has actually edited the label
    (0, react_1.useEffect)(() => {
        if (!hasUserEdited)
            return;
        const timeoutId = setTimeout(() => {
            dispatch((0, update_single_element_thunk_1.update_single_element_thunk)({
                data: {
                    document_id: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id,
                    payload: Object.assign(Object.assign({}, _element), { extra_attributes: Object.assign(Object.assign({}, _element.extra_attributes), { label: label }) }),
                },
            }));
        }, 300);
        return () => clearTimeout(timeoutId);
    }, [label, hasUserEdited]);
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Label", size: "small", value: label, borderColor: "border-borders", backgroundColor: "bg-white", onChange: (e) => {
                setLabel(e);
                setHasUserEdited(true);
            } }),
        react_1.default.createElement(lock_user_1.default, { userProp: (_d = (_c = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _c === void 0 ? void 0 : _c.user) !== null && _d !== void 0 ? _d : null, onClick: (user) => {
                dispatch((0, update_single_element_thunk_1.update_single_element_thunk)({
                    data: {
                        document_id: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id,
                        payload: Object.assign(Object.assign({}, _element), { extra_attributes: Object.assign(Object.assign({}, _element.extra_attributes), { user, user_id: user === null || user === void 0 ? void 0 : user._id, restricted: !!user }) }),
                    },
                }));
            } })));
}
